// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"299":"d0a40469","529":"220619ad"}[chunkId] + ".chunk.css";
};